<mat-dialog-content>
  <mat-horizontal-stepper linear #stepper>
    <!-- Step 1 -->
    <mat-step [stepControl]="plannedExceptionForm">
      <form [formGroup]="plannedExceptionForm">
        <ng-template matStepLabel>Configure Outage</ng-template>

        <h1>Planned {{ handoffType }} outage</h1>

        <h3>Select a date range:</h3>
        <p>
          This hand-off type will automatically become available again at store opening on the day following the
          designated end date.
        </p>

        @if (plannedExceptionForm.errors && plannedExceptionForm.touched) {
          <div>
            @if (plannedExceptionForm.errors.endBeforeStart) {
              <div class="error">Start date must be before the end date</div>
            }
          </div>
        }

        <div class="datepicker-container">
          <mat-form-field appearance="fill" class="datepicker-field">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="startOn" required />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="fill" class="datepicker-field">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="endOn" required />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <h3>Notify Customers:</h3>
        <p>
          Select a date to start notifying customers that this hand-off type is unavailable. This will display a message
          on the Meals 2GO app and website.
        </p>

        @if (plannedExceptionForm.errors && plannedExceptionForm.touched) {
          <div>
            @if (plannedExceptionForm.errors.startBeforeWarning) {
              <div class="error">Warning date must be before the start date</div>
            }
          </div>
        }
        <div class="datepicker-container">
          <mat-form-field appearance="fill" class="datepicker-field">
            <mat-label>Warning Date</mat-label>
            <input matInput [matDatepicker]="warningPicker" formControlName="showWarningOn" />
            <mat-datepicker-toggle matSuffix [for]="warningPicker"></mat-datepicker-toggle>
            <mat-datepicker #warningPicker></mat-datepicker>
          </mat-form-field>
        </div>

        @if (canApplyMultiStore()) {
          <div>
            <mat-checkbox formControlName="isMultiStore"> Apply this to more stores </mat-checkbox>
          </div>
        }

        <div class="button-container">
          <button mat-button type="button" (click)="onNoClick()">Cancel</button>
          <button
            mat-button
            matStepperNext
            mat-raised-button
            color="accent"
            [disabled]="plannedExceptionForm.invalid"
            class="next-button">
            Next
          </button>
        </div>
      </form>
    </mat-step>

    <!-- Step 2: Only shown if checkbox is selected -->
    @if (plannedExceptionForm.value.isMultiStore) {
      <mat-step [stepControl]="multiStoreForm" [editable]="true">
        <form [formGroup]="multiStoreForm">
          <ng-template matStepLabel>Select Stores</ng-template>
          <multi-store-dropdown
            [(facilities)]="facilities"
            [currentFacilityId]="currentFacilityId"
            (validationCheck)="facilityValidation()"></multi-store-dropdown>
          @if (multiStoreForm.controls["facilities"].invalid) {
            <div class="alert alert-danger">
              @if (multiStoreForm.controls["facilities"].errors) {
                <div>A Facility needs to be selected.</div>
              }
            </div>
          }
          <div class="button-container">
            <button mat-button type="button" (click)="onNoClick()">Cancel</button>
            <button mat-button matStepperPrevious type="button">Back</button>
            <button
              mat-button
              matStepperNext
              mat-raised-button
              color="accent"
              [disabled]="multiStoreForm.invalid"
              class="next-button">
              Next
            </button>
          </div>
        </form>
      </mat-step>
    }

    <!-- Step 3: Confirmation -->
    <mat-step>
      <ng-template matStepLabel>Confirm</ng-template>

      <p>{{ confirmationString() }}</p>

      <div class="button-container">
        <button mat-button type="button" (click)="onNoClick()">Cancel</button>
        <button mat-button matStepperPrevious type="button">Back</button>
        <button mat-flat-button mat-button mat-raised-button color="accent" (click)="saveAction()">Apply</button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</mat-dialog-content>
